export default __webpack_public_path__ + "static/media/ELEMENTOS_06.8ab4d355.png";